import { render } from "./instagram.vue?vue&type=template&id=4dda0a52"
import script from "./instagram.vue?vue&type=script&lang=js"
export * from "./instagram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__